// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { RejectedTransfer } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useRejectedTransfers: () => UseQueryResult<
  TemplateContract<RejectedTransfer>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useQueryWithOffset({
    queryKey: ['queryRejectedTransfers', operator],
    enabled: !!operator,
    queryFn: async (_, offset) => {
      return ledgerApi.queryRejectedTransfers(offset, operator);
    },
  });
};

export default useRejectedTransfers;
